module.exports = __webpack_public_path__ + "assets/28.jpg?fcbe852df16aa4673ee3774c52e8a4d6";